import { getInternalAppSdk } from '@/utils/internalAppSdk'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { SECOND_IN_MILLISECONDS } from '@vaultsfyi/common/constants'
import type { IntentStatusResponse } from '@vaultsfyi/common/schemas'

const crosschainTransactionStatusQueryKey = ['crosschainTransactionStatus'] as const

interface CrosschainTransactionStatusArgs {
  crosschainTransactionId: string | undefined
  enabled?: boolean
}

const crosschainTransactionStatusQueryOptions = ({
  crosschainTransactionId,
  enabled = true,
}: CrosschainTransactionStatusArgs) =>
  queryOptions({
    queryKey: [
      ...crosschainTransactionStatusQueryKey,
      {
        crosschainTransactionId,
      },
    ] as const,
    queryFn(): Promise<IntentStatusResponse> {
      const internalAppSdk = getInternalAppSdk()

      return internalAppSdk.getIntentStatus({ crosschainTransactionId: crosschainTransactionId! })
    },
    enabled: enabled && !!crosschainTransactionId,
    retry: 3,
    refetchInterval: (query) => {
      const data = query.state.data as IntentStatusResponse | null
      return data?.status === 'pending' ? 10 * SECOND_IN_MILLISECONDS : false
    },
    staleTime: 0,
  })

export const useCrosschainTransactionStatusQuery = (args: CrosschainTransactionStatusArgs) => {
  return useQuery({
    ...crosschainTransactionStatusQueryOptions(args),
  })
}
